



import { CodebookModel, TenantModel } from '@/libs/Api';
import { authStore } from '@/libs/auth/+store/store';
import { AuthAction, AuthGetter } from '@/libs/auth/models/auth-state';
import { codebooksStore } from '@/libs/codebooks/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { tenantsStore } from '@/libs/tenants/+state/store';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import Page from '@/Page.vue';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
@Component({})
export default class SidebarMenu extends Page {
    
    mounted () {
        const tenantId = authStore.useGetter(AuthGetter.GetTenant);
        if (tenantId && tenantId != "") {
			this.$router.push({ name: "Dashboard", params: { tenantId: tenantId } });
        }
        else {
            authStore.dispatch(AuthAction.SetTenant, "");
            applicationUserStore.dispatch(CrudAction.Get, {});
            this.subscribe(applicationUserStore, CrudReponse.Get).then((e: any) => {
                tenantsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<TenantModel>({
                    field: 'name',
                    order: 'asc'
                }));
                this.subscribe(tenantsStore, CrudReponse.GetAll).then((e: TenantModel[]) => {
                    if (e.length > 0) {
                        this.loadCodebooks().then(() => {
                            const tenantId = this.$route.params.tenantId;
                            if (tenantId == undefined && e.length > 0) {
                                authStore.dispatch(AuthAction.SetTenant, e[0].id!);
								this.$router.push({ name: "Dashboard", params: { tenantId: e[0].id! } });
                            }
                            else {
                                authStore.dispatch(AuthAction.SetTenant, tenantId);
                            }
                        });
                    }
                    else {
                        authStore.dispatch(AuthAction.SetTenant, "");
                        this.$router.push({ name: "UserSettings" });
                    }
                });
            });
        }
    }

    loadCodebooks () : Promise<any> {
        return new Promise((resolve, reject) => {
        codebooksStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<CodebookModel>());
            this.subscribe(codebooksStore, CrudReponse.GetAll).then((e: CodebookModel[]) => {
                resolve(e);
            }).catch((e: any) => {
                reject(e);
            });
        });
    }

}
